import { ws } from 'src/services'

export function validateAllowEdit (type, action) {
  // use this function as a decorator in methods that you wanna
  // validate the prop allowEdit of the component

  return function (target, key, descriptor) {
    const original = descriptor.value
    descriptor.value = function () {
      if (this.allowEdit[type][action]) {
        return original.apply(this, arguments)
      }
    }
  }
}

const lockerTypes = {
  none: '',
  ban: 'icon-bv-icones-nao',
  lock: 'icon-ptt-icons-trancar',
  unlocked: 'icon-ptt-icons-destrancar'
}

export const lockerStates = {
  'rh_denied': { color: '#00a2b5', classes: lockerTypes.ban, text: 'Rejeitado pelo gestor' },
  'rh_confirmed': { color: '#00a2b5', classes: lockerTypes.unlocked, text: 'Confirmado pelo gestor' },
  'rh_unilateral': { color: '#00a2b5', classes: lockerTypes.lock, text: 'Travado unilateralmente pelo gestor' },
  'employee_denied': { color: '#2c3e50', classes: lockerTypes.ban, text: `Rejeitado pelo ${ws('employee')}` },
  'employee_confirmed': { color: '#2c3e50', classes: lockerTypes.unlocked, text: `Confirmado pelo ${ws('employee')}` },
  'employee_unilateral': { color: '#2c3e50', classes: lockerTypes.lock, text: `Travado unilateralmente pelo ${ws('employee')}` },
  'all_confirmed': { color: '#0c9b73e8', classes: lockerTypes.lock, text: 'Travado bilateralmente' }
}
